import { useQuery } from '@tanstack/react-query'

import { LeaseDetails } from '@/models/features'

import { authAPI } from '../new-api'

export interface GetLeaseRequest {
  leaseId: string
}

export type GetLeaseResponse = LeaseDetails

export const getLease = async ({ leaseId }: GetLeaseRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<GetLeaseResponse>(`/lease/${leaseId}`, { signal })
  return response.data
}

export const GET_LEASE_BASE_QUERY_KEY = 'useGetLease'

export const getLeaseQueryKey = (data: GetLeaseRequest) => [GET_LEASE_BASE_QUERY_KEY, data] as const

export const useGetLease = (data: GetLeaseRequest) => {
  return useQuery({
    enabled: !!data.leaseId,
    queryFn: ({ signal }) => getLease(data, signal),
    queryKey: getLeaseQueryKey(data),
  })
}
